import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Button } from 'ui/button';
import { WarningFill } from 'ui/icons/status/WarningFill';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { Truncate } from 'ui/utility/truncate';
import { colors, spacing } from 'ui/theme';

const StyledButton = styled(Button)`
  &&& {
    background: ${(props: { isToggled?: boolean }) =>
      props.isToggled ? colors.white : colors.white};
    border: ${(props: { isToggled?: boolean }) =>
      props.isToggled
        ? `${spacing.single} solid ${colors.red100}`
        : `${spacing.single} solid ${colors.red100}`};
    color: ${colors.red100};
    box-shadow: none;
    &:hover {
      border: ${spacing.single} solid ${colors.red100};
    }
    svg {
      margin-left: ${spacing.threeEights};
    }
  }
`;

type FilterSegmentProps = {
  onClick: () => void;
  isToggled?: boolean;
  'data-test'?: string;
};

export const FilterSegmentErrorButton: React.FC<React.PropsWithChildren<FilterSegmentProps>> = ({
  children,
  ...props
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (ref?.current?.offsetWidth && ref?.current?.offsetWidth < ref?.current?.scrollWidth) {
      setIsTruncated(true);
    }
  });
  return (
    <Tooltip isEnabled={isTruncated} tooltipContent={children}>
      <StyledButton {...props}>
        <Truncate maxWidth={168} ref={ref}>
          {children}
        </Truncate>
        <WarningFill color={colors.red100} />
      </StyledButton>
    </Tooltip>
  );
};
